import * as React from 'react';

var resources = {
  StaticArrowThinCollapseSymbolLine: /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.116 6.116a1.25 1.25 0 0 1 1.666-.091l.102.091 9.5 9.5a1.25 1.25 0 0 1-1.666 1.859l-.102-.091L12 8.767l-8.616 8.617a1.25 1.25 0 0 1-1.666.091l-.102-.091a1.25 1.25 0 0 1-.091-1.666l.091-.102 9.5-9.5Z"
  })),
  StaticArrowThinDropdownSymbolLine: /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.616 7.616a1.25 1.25 0 0 1 1.666-.091l.102.091L12 16.233l8.616-8.617a1.25 1.25 0 0 1 1.666-.091l.102.091a1.25 1.25 0 0 1 .091 1.666l-.091.102-9.5 9.5a1.25 1.25 0 0 1-1.666.091l-.102-.091-9.5-9.5a1.25 1.25 0 0 1 0-1.768Z"
  }))
};
function isStaticResource(resource) {
  return resource in resources;
}

export { isStaticResource, resources };
//# sourceMappingURL=resources.js.map
